<template>
  <section>
    <sequence-navigation v-if="feature === 'sequences'" />
    <builder-nav :feature="feature" legacy />
    <nav v-if="feature === 'automations'" class="groove-builder-tabs" aria-label="Legacy automation editors">
      <router-link to="/automations/legacy">Classic automations</router-link>
      <router-link to="/automations-v2">Visual automations</router-link>
    </nav>
    <component :is="legacyComponent" v-bind="feature === 'sequences' ? { showNavigation: false } : {}" />
  </section>
</template>
<script>
import BuilderNav from './BuilderNav.vue';
import SequenceNavigation from './SequenceNavigation.vue';
import Automations from '../../pages/automations/index.vue';
import AutomationV2 from '../../pages/automations-v2/index.vue';
import Sequences from '../../pages/sequences/index.vue';
import Segments from '../../pages/segments/index.vue';
export default {
  middleware: 'auth', layout: 'defaultWithoutVuePerfectScrollbar', components: { BuilderNav, SequenceNavigation },
  props: { feature: { type: String, required: true }, visual: Boolean },
  computed: { legacyComponent() { return this.feature === 'automations' ? (this.visual ? AutomationV2 : Automations) : this.feature === 'sequences' ? Sequences : Segments; } }
};
</script>
